import React from 'react';
import { DownArrow } from '@producer/ui-kit';
import { ExitIcon } from '@radix-ui/react-icons';

import { useAuth } from '../../../cree8-auth';
import { authStore } from '../../../core/stores/auth-store';
import { DropdownMenu } from '../../../components/modals/dropdown-menu/DropdownMenu';

import styles from './user-dropdown.module.scss';
export const UserDropdown: React.FC = () => {
  const user = authStore.currentUser;
  const auth = useAuth();

  const logout = () => {
    void auth.signoutRedirect();
  };

  const options = [
    {
      title: 'Logout',
      onSelect: logout,
      icon: <ExitIcon />,
      type: 'danger' as const,
    },
  ];

  if (!user) {
    return null;
  }

  return (
    <DropdownMenu
      items={options}
      trigger={
        <div className={styles['trigger']}>
          <div className={styles['wrapper']}>
            <span className={styles['label']}>Logged in as</span>
            <span className={styles['username']}>{user?.email}</span>
          </div>

          <DownArrow />
        </div>
      }
    />
  );
};
